"use client";

import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import { Text, TextColor, TextSize } from "../../components/Text";
export const ProductGallery = ({
  images
}) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const [showAllThumbnails, setShowAllThumbnails] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomPosition, setZoomPosition] = useState({
    x: 50,
    y: 50
  });
  const [isMobile, setIsMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [hoverPosition, setHoverPosition] = useState({
    x: 50,
    y: 50
  });
  const thumbnailsRef = useRef(null);
  const imageRef = useRef(null);
  const mobileScrollRef = useRef(null);
  const visibleThumbnails = showAllThumbnails ? images : images.slice(0, 5);

  // Sprawdź czy urządzenie jest mobilne
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Handle scroll detection on mobile
  useEffect(() => {
    if (!isMobile || !mobileScrollRef.current) return;
    const container = mobileScrollRef.current;
    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const containerWidth = container.clientWidth;

      // Calculate which image is currently in view
      const currentImageIndex = Math.round(scrollLeft / containerWidth);

      // Update selectedImage if it's different
      if (currentImageIndex !== selectedImage && currentImageIndex >= 0 && currentImageIndex < images.length) {
        setSelectedImage(currentImageIndex);
      }
    };
    container.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [isMobile, selectedImage, images.length]);
  const handleMoreClick = () => {
    setShowAllThumbnails(true);
    // Płynny scroll do nowych miniaturek
    setTimeout(() => {
      if (thumbnailsRef.current) {
        const newThumbnails = thumbnailsRef.current.querySelectorAll(".thumbnail");
        if (newThumbnails[3]) {
          newThumbnails[3].scrollIntoView({
            behavior: "smooth",
            block: "nearest"
          });
        }
      }
    }, 50);
  };
  const openFullscreen = () => {
    setIsFullscreen(true);
    // Blokuj scroll na body
    document.body.style.overflow = "hidden";
  };
  const closeFullscreen = () => {
    setIsFullscreen(false);
    setIsZoomed(false);
    // Przywróć scroll na body
    document.body.style.overflow = "unset";
  };
  const handleImageClick = e => {
    if (!isZoomed) {
      // Przybliż i ustaw pozycję na podstawie miejsca kliknięcia
      const rect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width * 100;
      const y = (e.clientY - rect.top) / rect.height * 100;
      setZoomPosition({
        x,
        y
      });
      setIsZoomed(true);
    } else {
      // Oddal
      setIsZoomed(false);
    }
  };
  const handleMouseMove = e_0 => {
    if (isZoomed && imageRef.current) {
      const rect_0 = imageRef.current.getBoundingClientRect();
      const x_0 = (e_0.clientX - rect_0.left) / rect_0.width * 100;
      const y_0 = (e_0.clientY - rect_0.top) / rect_0.height * 100;
      setZoomPosition({
        x: Math.max(0, Math.min(100, x_0)),
        y: Math.max(0, Math.min(100, y_0))
      });
    }
  };
  const handleMouseEnter = () => {
    if (!isMobile) {
      setIsHovered(true);
    }
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const handleMouseMoveOnMain = e_1 => {
    if (isHovered && !isMobile) {
      const rect_1 = e_1.currentTarget.getBoundingClientRect();
      const x_1 = (e_1.clientX - rect_1.left) / rect_1.width * 100;
      const y_1 = (e_1.clientY - rect_1.top) / rect_1.height * 100;
      setHoverPosition({
        x: x_1,
        y: y_1
      });
    }
  };

  // Obsługa klawiszy w fullscreen
  const handleKeyDown = e_2 => {
    if (!isFullscreen) return;
    if (e_2.key === "Escape") {
      if (isZoomed) {
        setIsZoomed(false);
      } else {
        closeFullscreen();
      }
    } else if (e_2.key === "ArrowLeft") {
      setSelectedImage(selectedImage - 1 < 0 ? images.length - 1 : selectedImage - 1);
      setIsZoomed(false);
    } else if (e_2.key === "ArrowRight") {
      setSelectedImage(selectedImage + 1 > images.length - 1 ? 0 : selectedImage + 1);
      setIsZoomed(false);
    }
  };
  React.useEffect(() => {
    if (isFullscreen) {
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [isFullscreen, selectedImage, isZoomed]);
  React.useEffect(() => {
    setIsZoomed(false);
    setIsHovered(false);
  }, [selectedImage]);
  return <>
      <div className={`flex ${isMobile ? "flex-col" : "gap-4"} max-w-4xl`}>
        {/* Miniaturki po lewej */}
        <div ref={thumbnailsRef} className="flex flex-col gap-2 overflow-y-auto relative">
          {!isMobile && visibleThumbnails.map((image, index) => <button key={index} onClick={() => setSelectedImage(index)} onMouseEnter={() => setSelectedImage(index)} className={`thumbnail relative w-16 h-20 border-2 transition-all ${selectedImage === index ? "border-gray-800" : "border-gray-200 hover:border-gray-400"}`}>
                <Image src={image.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={`Zdjęcie produktu ${index + 1}`} fill className="object-cover" sizes="64px" quality={100} priority={index < 3} unoptimized={false} />
              </button>)}

          {/* Przycisk "więcej" - pokazuj tylko gdy nie wszystkie są widoczne */}
          {!showAllThumbnails && images.length > 5 && <button onClick={handleMoreClick} className="w-16 h-20 border-2 border-gray-200 hover:border-gray-400 bg-gray-50 flex items-center justify-content transition-all">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="6,9 12,15 18,9"></polyline>
              </svg>
            </button>}
        </div>

        {/* Główne zdjęcie */}
        <div className="relative flex-1 aspect-[3/4] bg-gray-100 overflow-hidden">
          {/* Główne zdjęcie na desktop / Horizontal scroll na mobile */}
          {isMobile ? <div className="relative">
              <div className="absolute h-8 left-0 bottom-0 text-black hover:text-gray-300 z-10 bg-white bg-opacity-80 p-2">
                <Text text={`${selectedImage + 1} z ${images.length}`} color={TextColor.BLACK} fontSize={TextSize.XS} />
              </div>

              <div ref={mobileScrollRef} className="flex overflow-x-auto scrollbar-hide" style={{
            scrollPaddingLeft: "0px",
            scrollBehavior: "smooth",
            scrollSnapType: "x mandatory",
            touchAction: "pan-x pan-y",
            scrollbarWidth: "none",
            // Firefox
            msOverflowStyle: "none" // IE/Edge
          }}>
                {images.map((image_0, index_0) => <div key={index_0} className="flex-shrink-0 w-full aspect-[3/4] relative" style={{
              scrollSnapAlign: "center"
            }}>
                    <Image src={image_0.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={`Zdjęcie produktu ${index_0 + 1}`} fill className="object-cover cursor-zoom-in" onClick={openFullscreen} sizes="100vw" quality={100} priority={index_0 === selectedImage} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R+pTXyqmKo16HTXvLQAz5F88+dL2Xyk3t8VJWWIDPNEfg=" />
                  </div>)}
              </div>
            </div> :
        // Desktop version pozostaje bez zmian
        <div className="relative flex-1 aspect-[3/4] bg-gray-100 overflow-hidden">
              <Image src={images[selectedImage]?.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl") || ""} alt={`Główne zdjęcie produktu ${selectedImage + 1}`} fill className={`object-cover cursor-zoom-in transition-transform duration-300 ${isHovered ? "scale-[2]" : "scale-100"}`} priority sizes="(max-width: 768px) 100vw, 70vw" quality={100} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onMouseMove={handleMouseMoveOnMain} onClick={openFullscreen} placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R+pTXyqmKo16HTXvLQAz5F88+dL2Xyk3t8VJWWIDPNEfg=" style={{
            transformOrigin: isHovered ? `${hoverPosition.x}% ${hoverPosition.y}%` : "center"
          }} />
            </div>}
        </div>
      </div>

      {/* Fullscreen Modal */}
      {isFullscreen && <div className="fixed inset-0 bg-white z-50 flex flex-col md:flex-row">
          {!isMobile ? <>
              <button onClick={closeFullscreen} className="absolute top-4 right-4 text-black hover:text-gray-600 z-10">
                <Close className="!w-8 !h-8" />
              </button>

              <div className="w-24 bg-white bg-opacity-20 p-2 flex flex-col gap-2 overflow-y-auto">
                {images.map((image_1, index_1) => <button key={index_1} onClick={() => setSelectedImage(index_1)} className={`relative w-20 h-32 border-2 transition-all flex-shrink-0 ${selectedImage === index_1 ? "border-gray-600" : "border-gray-200 hover:border-gray-400"}`}>
                    <Image src={image_1.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl")} alt={`Miniaturka ${index_1 + 1}`} fill className="object-cover" sizes="80px" quality={85} />
                  </button>)}
              </div>
            </> : null}

          {/* Główne zdjęcie w fullscreen */}
          <div className="flex-1 relative flex items-center justify-center overflow-hidden">
            {/* Strzałki - teraz zawsze widoczne z pętlą */}
            {!isZoomed && !isMobile && <button onClick={() => setSelectedImage(selectedImage - 1 < 0 ? images.length - 1 : selectedImage - 1)} className="absolute left-4 top-1/2 transform -translate-y-1/2 text-black hover:text-gray-300 z-10 bg-white bg-opacity-80 rounded-full p-2">
                <ArrowBackIos className="!w-8 !h-8" />
              </button>}

            {!isZoomed && !isMobile && <button onClick={() => setSelectedImage(selectedImage + 1 > images.length - 1 ? 0 : selectedImage + 1)} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-black hover:text-gray-300 z-10 bg-white bg-opacity-80 rounded-full p-2">
                <ArrowForwardIos className="!w-8 !h-8" />
              </button>}

            <div ref={imageRef} className={`relative w-full h-full transition-transform duration-300 ${isZoomed ? "cursor-zoom-out" : "cursor-zoom-in"}`} onClick={handleImageClick} onMouseMove={handleMouseMove} style={{
          transform: isZoomed ? "scale(2.5)" : "scale(1)",
          transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`
        }}>
              <Image src={images[selectedImage]?.url.replace("http://localhost/prestashop", "https://shop.carry.pl").replace("carry-prestashop.ulam.tech", "shop.carry.pl") || ""} alt={`Pełnoekranowe zdjęcie produktu ${selectedImage + 1}`} fill className={`${isMobile ? "object-cover" : "object-contain"} pointer-events-none`} sizes="100vw" quality={100} priority placeholder="blur" blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R+pTXyqmKo16HTXvLQAz5F88+dL2Xyk3t8VJWWIDPNEfg=" />
            </div>
          </div>

          {isMobile && <div className="absolute bottom-0 w-full h-20 bg-white px-8 py-4 flex items-center justify-between">
              <Text text={`${selectedImage + 1} z ${images.length}`} color={TextColor.BLACK} />

              <div className="flex items-center gap-8">
                <div className="flex items-center gap-4">
                  <button onClick={() => setSelectedImage(selectedImage - 1 < 0 ? images.length - 1 : selectedImage - 1)} className="text-black hover:text-gray-600">
                    <ArrowBackIos className="!w-6 !h-6" />
                  </button>
                  <button onClick={() => setSelectedImage(selectedImage + 1 > images.length - 1 ? 0 : selectedImage + 1)} className="text-black hover:text-gray-600">
                    <ArrowForwardIos className="!w-6 !h-6" />
                  </button>
                </div>

                <button onClick={closeFullscreen} className="text-black hover:text-gray-600">
                  <Close className="!w-8 !h-8" />
                </button>
              </div>
            </div>}
        </div>}
    </>;
};